import accessModes from '@/vocabularies/accessModes.js'
import moment from 'moment'

export default function (content) {
  let firstPart = ''
  let secondPart = ''
  let thridPart = ''

  // form the first part
  if (content.authors && content.authors.length > 0 && content.authors.length < 5) {
    firstPart = formatAuthor(content.authors[0], true)
  }
  if (firstPart && content.title) {
    firstPart += ` ${content.title}`
  } else {
    firstPart = content.title
  }

  // form the second part
  if (content.authors && content.authors.length > 0) {
    secondPart = content.authors.slice(0, 4).map(a => formatAuthor(a, false)).join(', ')
    if (content.authors.length >= 5) {
      secondPart += ' и др.'
    }
  }

  // form the third part
  let subParts = []
  if (content.source) {
    let value = content.source
    if (content.type === 'resource') {
      value += '[сайт]'
    }
    subParts.push(value)
  }
  if (content.year) {
    subParts.push(`${content.year} г.`)
  }
  if (content.issue) {
    subParts.push(`№ ${content.issue}`)
  }
  if (content.pages) {
    subParts.push(`С. ${content.pages}`)
  }
  if (content.type === 'resource' && content.url) {
    let values = [`режим доступа: ${content.url}`]

    if (content.accessMode) {
      const value = accessModes.find(am => am.key === content.accessMode)
      if (value) {
        values.push(value.title)
      }
    }

    if (content.accessDate) {
      const dateValue = moment(content.accessDate, 'YYYY-MM-DD')
      if (dateValue) {
        values.push('(дата обращения: ' + dateValue.format('DD.MM.YYYY') + ')')
      }
    }

    values.push('— Загл. с экрана.')

    subParts.push(values.join(' '))
  }
  if (subParts.length > 0) {
    thridPart = subParts.join(' — ')
  }

  let result = ''
  if (firstPart && secondPart) {
    result = `${firstPart} / ${secondPart}`
  } else if (firstPart && !secondPart) {
    result = firstPart
  } else if (!firstPart && secondPart) {
    result = secondPart
  }
  if (thridPart) {
    result += ` // ${thridPart}`
  }
  return result
}

function formatAuthor (content, lastNameFirst = true) {
  let initials = `${content.firstNameInitial}.`
  if (content.extraNameInitial) {
    initials += ` ${content.extraNameInitial}.`
  }
  return lastNameFirst ? `${content.lastName}, ${initials}` : `${initials} ${content.lastName}`
}



// WEBPACK FOOTER //
// ./src/shared/linkFormat.js